import { CommonModule } from '@angular/common';
import type { OnDestroy, OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import type { Subscription } from 'rxjs';

import type { LoaderState } from '../../models/loader-state';
import { ApiLoaderService } from '../../services/api-loader.service';

@Component({
  selector: 'app-api-loader',
  imports: [CommonModule],
  templateUrl: './api-loader.component.html',
  styleUrl: './api-loader.component.scss',
})
export class ApiLoaderComponent implements OnInit, OnDestroy {
  loaderService = inject(ApiLoaderService);
  show = false;
  private subscription!: Subscription;

  ngOnInit(): void {
    this.subscription = this.loaderService.loaderState.subscribe((state: LoaderState) => {
      this.show = state.show;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
